import { flexRender, type Cell, type ReactTable, type RowData } from "@tanstack/react-table";
import { createElement } from "react";
import type { AppTableFeatures } from "./useAppTable";

export function renderAppTableCell<TData extends RowData>(table: ReactTable<AppTableFeatures, TData, unknown>, cell: Cell<AppTableFeatures, TData, unknown>) {
  // TanStack also marks ordinary tree parents as aggregated because they have subRows.
  // Only generated grouping rows should use the aggregate renderer.
  if (cell.row.subRows.length && !cell.row.getIsGrouped() && !cell.getIsPlaceholder()) {
    return flexRender(cell.column.columnDef.cell, cell.getContext());
  }

  return createElement(table.FlexRender, { cell });
}
